// ======================================================================
// File Name       : UserfrontTopScreenContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { change, getFormValues, isDirty, isInvalid, reduxForm } from 'redux-form';
import * as userfrontImageAction from '../../actions/UserFrontImageAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import ThumbNail from '../../components/userfront/ThumbNail';
import TopScreenSetting from '../../components/userfront/TopScreenSetting';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { isUserfrontImageTopType, TOP_SCREEN_KEY_LIST, USERFRONT_IMAGE_SCREEN_TYPE } from '../../constants/UserfrontImageConstants';
import { downLoadFile } from '../../utils/ApiUtils';
import { hasProperty } from '../../utils/index';
import RenderField from '../../utils/ReduxFormUtils';
import { INITIAL_IMAGE } from '../../constants/InitialImageConstants';

class UserfrontTopScreenContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialData: {
        imageType: null,
        imageFileUpload: null,
        thumbnailUrl: '',
        imageOptionalUrl: '',
      },
      initialImageList: [],
      initialImageObject: null,
      okBtnClick: false,
      saveDisplayBtnClick: false,
    };
    this.handleImageFileChange = this.handleImageFileChange.bind(this);
    this.getInitialTopImage = this.getInitialTopImage.bind(this);
    this.onConfirmDialogOk = this.onConfirmDialogOk.bind(this);
    this.createParamUpload = this.createParamUpload.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(
      this,
      MessageTemplate.MSG_USERFRONT_DISPLAY_SETTING_CONFIRM,
      null,
    );
    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.onOk = this.onOk.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  componentDidMount() {
    this.getInitialTopImage();
  }

  getInitialTopImage() {
    const paramGetInitialTopImage = {};
    this.props.dispatch(userfrontImageAction.getInitialTopImage(paramGetInitialTopImage));
  }

  componentWillUnmount() {
    this.props.dispatch(userfrontImageAction.resetInitState());
  }

  handleImageFileChange(event) {
    if (event.target.files.length !== 0) {
      const nameTarget = event.target.name;
      const { imageObject, dispatch } = this.props;
      const reader = new FileReader();
      const file = event.target.files[0];
      if (imageObject && Object.keys(imageObject).length) {
        const place = nameTarget.indexOf('.');
        const nameKey = nameTarget.slice(0, place);
        if (hasProperty(imageObject, nameKey)) {
          reader.onloadend = () => {
            const newFormValue = { ...imageObject[nameKey] };
            newFormValue.imageFileUpload = file;
            newFormValue.thumbnailUrlFileLoad = reader.result;
            newFormValue.changed = true;

            const id = `${nameKey}.imageFileUpload`;
            $(`#${id}`).val('');
            dispatch(change('userfrontImageTop', nameKey, newFormValue));
            dispatch(userfrontImageAction.changeImageFile(nameKey, newFormValue));
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  openConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  /**
   * Action when click OK button in dialog from 表示設定を保存する button
   */
  onConfirmDialogOk() {
    const { formValues } = this.props;
    this.setState({ showExportModal: false, saveDisplayBtnClick: true }, () => {
      if (formValues && Object.keys(formValues).length) {
        const { heroAreaFlag, bannerFlag1, bannerFlag2, bannerFlag3, bannerUrl1, bannerUrl2, bannerUrl3 } = formValues;
        const params = {
          heroAreaFlag,
          bannerFlag1,
          bannerFlag2,
          bannerFlag3,
          bannerUrl1,
          bannerUrl2,
          bannerUrl3,
        };

        this.props.dispatch(userfrontImageAction.updateDisplaySetting(params)).then((error) => {
          this.setState({ saveDisplayBtnClick: false });
          if (!error) {
            this.getInitialTopImage();
            // Hide error message after uploading thumbnail successful
            this.props.dispatch({ type: HIDE_MESSAGE });
          }
        });
      }
    });
  }

  /**
   * Action when click OK button
   */
  onOk() {
    const { auth, formValues } = this.props;
    const listParams = [];
    this.setState({ showExportModal: false, okBtnClick: true}, () => {
      if (formValues && Object.keys(formValues).length) {
        Object.keys(formValues).map((childKey) => {
          if (hasProperty(formValues, childKey)) {
            if (formValues[childKey] && Object.keys(formValues[childKey]).length) {
              const { userfrontImageType } = formValues[childKey];
              if (isUserfrontImageTopType(userfrontImageType)) {
                const param = this.createParamUpload(formValues[childKey]);
                if (param) listParams.push(param);

                const newFormValue = { ...formValues[childKey] };
                delete newFormValue.changed;
                this.props.dispatch(change('userfrontImageTop', childKey, newFormValue));
              }
            }
          }
          return null;
        });
      }
      if (listParams.length > 0) {
        this.props.dispatch(userfrontImageAction.editInitialImage(auth, listParams)).then((error) => {
          this.setState({ okBtnClick: false });
          if (!error) {
            const container = $('#sroll-container');
            if (container && container.length) {
              container.scrollTop(0);
            }
            this.getInitialTopImage();
            // Hide error message after uploading thumbnail successful
            this.props.dispatch({ type: HIDE_MESSAGE });
          }
        });
      }
    });
  }

  createParamUpload(obj) {
    if (!obj) return null;
    if (!obj.changed) return null;
    const param = {};
    param.userfrontImageType = obj.userfrontImageType;
    param.multilangType = obj.multilangType;
    obj.imageFileUpload && (param.uploadFile = obj.imageFileUpload);
    param.imageUpdateType = obj.imageUpdateType;
    return param;
  }

  handleChangeOption(value) {
    const { dispatch, imageObject } = this.props;
    const languageSetting = parseInt(value, 10);
    const params = {
      userfrontScreenType: USERFRONT_IMAGE_SCREEN_TYPE.TOP,
      languageSetting,
    };

    dispatch(change('userfrontImageTop', 'languageSetting', languageSetting));
    if (imageObject && Object.keys(imageObject).length) {
      Object.keys(imageObject).map((childKey) => {
        if (hasProperty(imageObject, childKey)) {
          if (imageObject[childKey] && Object.keys(imageObject[childKey]).length) {
            const newFormValue = { ...imageObject[childKey] };
            delete newFormValue.changed;
            dispatch(change('userfrontImageTop', childKey, newFormValue));
          }
        }
        return null;
      });
    }
    dispatch(userfrontImageAction.changeUserfrontImageData(params));
  }

  static getDerivedStateFromProps(nextProps) {
    const { dispatch, imageObject } = nextProps;
    if (nextProps && nextProps.formValues && Object.keys(nextProps.formValues).length) {
      TOP_SCREEN_KEY_LIST.map((childKey) => {
        if (nextProps.formValues[childKey] && !nextProps.formValues[childKey].dataUrl) {
          const reader = new FileReader();
          const newFormValue = { ...imageObject[childKey] };
          downLoadFile(nextProps.formValues[childKey].userfrontImageUrl).then((blob) => {
            reader.onloadend = () => {
              newFormValue.dataUrl = reader.result;
              dispatch(change('userfrontImageTop', childKey, newFormValue));

              const params = {
                key: childKey,
                dataUrl: reader.result,
              };
              dispatch(userfrontImageAction.getImageData(params));
            };
            reader.readAsDataURL(blob);
          });
        }
      });
    }
  }

  onChangeCheckbox(event) {
    const { dispatch, userfrontImageTop } = this.props;
    if (userfrontImageTop && Object.keys(userfrontImageTop).length) {
      const nameTarget = event.target.name;
      const place = nameTarget.indexOf('.');
      const nameKey = nameTarget.slice(0, place);
      if (hasProperty(userfrontImageTop.values, nameKey)) {
        const newFormValue = { ...userfrontImageTop.values[nameKey] };
        if (event.target.checked) {
          newFormValue.changed = true;
          newFormValue.imageUpdateType = INITIAL_IMAGE.IMAGE_SYSTEMS;
        } else {
          delete newFormValue.changed;
          newFormValue.imageUpdateType = INITIAL_IMAGE.IMAGE_SELECTION;
        }
        newFormValue.thumbnailUrlFileLoad = '';
        newFormValue.imageFileUpload = '';

        const id = `${nameKey}imageFileUpload`;
        $(`#${id}`).val('');
        dispatch(change('userfrontImageTop', nameKey, newFormValue));
      }
    }
  }

  render() {
    const { invalid, imageObject, userfrontImageTop, isEnableRegistBtn, isOEMUser } = this.props;

    return (
      <div>
        <Form className='form-horizontal'>
          <Col sm={12} className="padding-left-right-clear bold">
            <h3>受講ユーザーがログインした後に、表示されるトップ画面のイメージやメニューのリンク先を変更します。</h3>
          </Col>
          <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
            <h3 className="margin-top-10">ステップ１）表示させるエリアを選ぶ</h3>
            <h3 className="margin-top-10">表示させるエリアにチェックを入れた後に、「表示設定を保存する」を押してください。</h3>
            <h3 className="margin-top-10">バナーエリアに関しては、リンク先も設定できます。</h3>
          </Col>
          <Col sm={12} className="margin-top-20">
            <TopScreenSetting
              formValues={userfrontImageTop}
            />
          </Col>
          <Col sm={12} className="margin-bottom-20 padding-left-right-clear">
            <Button
              variant="primary"
              className="btn-96 text-center margin-top-20"
              onClick={this.openConfirmDialog}
              disabled={this.state.saveDisplayBtnClick}
            >
              表示設定を保存する
            </Button>
          </Col>
          <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
            <h3 className="margin-top-10">ステップ２）画像を登録する</h3>
            <h3 className="margin-top-10">画像は言語ごとに設定することができます。設定する言語を選んでから、各エリアに表示させる画像を設定してください。</h3>
            <h3 className="margin-top-10">ご利用できるファイル形式はpng形式のみとなります。</h3>
          </Col>
          <Col sm={12} className="margin-top-20 padding-left-right-clear">
            <Col sm={12} className="margin-top-10 padding-left-right-clear bold">
              言語設定
            </Col>
            <Col sm={2} className="margin-top-10 padding-left-right-clear">
              <RenderField
                type="selectbox"
                name="languageSetting"
                label="言語設定"
                data={SELECT_BOX_DATA.USERFRONT_LANGUAGE_SETTING_TYPE}
                handleChangeOption={this.handleChangeOption}
              />
            </Col>
          </Col>
          <Col sm={12} className="margin-top-20">
            <Col sm={12} className="margin-top-10 padding-left-right-clear">
              <ThumbNail
                formValues={imageObject}
                handleImageFileChange={this.handleImageFileChange}
                radioChange={this.radioChange}
                onChangeCheckbox={this.onChangeCheckbox}
                isOEMUser={isOEMUser} // Step 10.3.0
              />
            </Col>
          </Col>
          <Col sm={12} className="margin-bottom-20 padding-left-right-clear">
            <Button
              variant="primary"
              className="btn-96 text-center margin-top-20"
              onClick={this.onOk} // call api directly
              disabled={invalid || !isEnableRegistBtn || this.state.okBtnClick}
            >
              画像を登録
            </Button>
          </Col>
          <DialogConfirm
            showModal={this.state.showExportModal}
            mdSize={this.mdSize}
            content={MessageTemplate.MSG_USERFRONT_DISPLAY_SETTING_CONFIRM}
            onOK={this.onConfirmDialogOk}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userfrontImage, authed: { authedUser: { isOEMUser } } } = state;
  const {
    initialData,
    imageObject,
    initialImageObject,
    languageSetting,
  } = userfrontImage;

  const { userfrontImageTop } = state.form;
  if (userfrontImageTop && userfrontImageTop.values) {
    if (userfrontImageTop.values.languageSetting === undefined && languageSetting) {
      initialImageObject.languageSetting = languageSetting;
    }
  }
  const formValues = getFormValues('userfrontImageTop')(state);
  const invalid = isInvalid('userfrontImageTop')(state);
  let isEnableRegistBtn = false;

  if (formValues && Object.keys(formValues).length > 0 && imageObject && Object.keys(imageObject).length > 0) {
    TOP_SCREEN_KEY_LIST.map((childKey) => {
      const data = formValues[childKey];
      if (data) {
        const isManualFileSelection = data.imageUpdateType && data.imageUpdateType === INITIAL_IMAGE.IMAGE_SELECTION;
        imageObject[childKey].isManualFileUpload = data.isEnableFileUpload && isManualFileSelection;
        if (hasProperty(data, 'changed')) {
          imageObject[childKey].changed = data.changed;
          imageObject[childKey].imageUpdateType = data.imageUpdateType;
          isEnableRegistBtn =
            data.imageUpdateType === INITIAL_IMAGE.IMAGE_SYSTEMS ||
            (data.imageUpdateType === INITIAL_IMAGE.IMAGE_SELECTION &&
              hasProperty(data, "imageFileUpload") &&
              data.imageFileUpload !== "");
        }
      }
    });
  }
  return {
    initialData,
    initialValues: initialImageObject,
    imageObject,
    formValues,
    invalid,
    ...{ userfrontImageTop },
    isEnableRegistBtn,
    isOEMUser, // Step 10.3.0
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'userfrontImageTop', // a unique identifier for this form
    enableReinitialize: true,
  })(UserfrontTopScreenContainer),
);
